import { lazyGetDictationLanguagePickerDropDown } from '../index';
import { default as setDictationLanguagePickerDropdown } from '../actions/setDictationLanguagePickerDropdown';

export default async function loadSetDictationLanguageMenu(): Promise<void> {
    const getDictationLanguagePickerDropDown = await lazyGetDictationLanguagePickerDropDown.import();
    setDictationLanguagePickerDropdown(getDictationLanguagePickerDropDown());
}
